import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useMemo } from "react";

import { type ExtendedExternalIntegrationType, ExtendedExternalIntegrationTypes } from "../types";
import { useGetWorkplaceExternalIntegrations } from "./useGetWorkplaceExternalIntegrations";

interface UseGetWorkplaceEnabledConfigurationsParams {
  workplaceId: string;
}

export function useGetWorkplaceEnabledConfigurations(
  params: UseGetWorkplaceEnabledConfigurationsParams
): ExtendedExternalIntegrationType[] {
  const { workplaceId } = params;

  const { data: externalIntegrations } = useGetWorkplaceExternalIntegrations({ workplaceId });

  const timeclockComplianceFlag = useCbhFlag(CbhFeatureFlag.TIMECLOCK_COMPLIANCE_ROLLOUT, {
    defaultValue: { state: "disabled" },
  });

  return useMemo(() => {
    const types: ExtendedExternalIntegrationType[] = (externalIntegrations ?? [])
      .filter((integration) => integration.isEnabled)
      .map((integration) => integration.type);

    if (timeclockComplianceFlag.state === "enabled") {
      types.push(ExtendedExternalIntegrationTypes.TIMECLOCK_COMPLIANCE);
    }

    return types;
  }, [externalIntegrations, timeclockComplianceFlag.state]);
}
